export default __webpack_public_path__ + "static/envelope-4-07a62dbcd0af73a89427d1085994e052.webp";